import { User } from '@ellf/app-shared-user';
import { TokenDto } from '@ellf/common-dto';
import { createAction, props } from '@ngrx/store';

export const getLoggedUser = createAction(`[Auth] Get logged user`);

export const getLoggedUserSuccess = createAction(
  `[Auth] Get logged user success`,
  props<{ loggedUser: User }>()
);

export const getLoggedUserFail = createAction(
  `[Auth] Get logged user fail`,
  props<{ error: string }>()
);

export const logout = createAction(`[Auth] Logout`);
export const logoutSuccess = createAction(`[Auth] Logout success`);
export const logoutFailure = createAction(
  `[Auth] Logout failure`,
  props<{ error: string }>()
);
export const setUserMustResetPassword = createAction(
  '[Auth] User must reset password'
);

export const loginWithAAD = createAction(
  `[Auth] AAD Login`,
  props<{ rememberMe: boolean }>()
);
export const loginWithAADSuccess = createAction(
  '[Auth] AAD Login Success',
  props<{ result: TokenDto }>()
);
export const loginWithAADFailure = createAction(
  '[Auth] AAD Login Failure',
  props<{ error: string }>()
);

export const login = createAction(
  '[Auth] Login',
  props<{
    username: string;
    password: string;
    rememberMe: boolean;
    newPassword?: string;
  }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ result: TokenDto }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string; userMustResetPassword?: boolean }>()
);

export const forgotPassword = createAction(
  '[Auth] Forgot password',
  props<{ username: string }>()
);
export const forgotPasswordSuccess = createAction(
  '[Auth] Forgot password Success'
);
export const forgotPasswordFailure = createAction(
  '[Auth] Forgot password Failure',
  props<{ error: string }>()
);

export const resetPassword = createAction(
  '[Auth] Reset password submit',
  props<{ token: string; newPassword: string }>()
);
export const resetPasswordSuccess = createAction(
  '[Auth] Reset password submit Success'
);
export const resetPasswordFailure = createAction(
  '[Auth] Reset password submit Failure',
  props<{ error: string }>()
);

export const sessionExpired = createAction(`[Auth] SessionExpired`);

//CheckAuth
export const checkAADAuth = createAction('[Auth] Check auth');
export const checkAuthSuccess = createAction(
  '[Auth] Check auth success',
  props<{ loggedIn: boolean }>()
);
export const checkAuthFail = createAction(
  '[Auth] Check auth fail',
  props<{ error: string }>()
);

export const forceRefresh = createAction('[Auth] Force refresh');
export const forceRefreshSucces = createAction(
  '[Auth] Force refresh success',
  props<{ result: any }>()
);
export const forceRefreshFail = createAction(
  '[Auth] Force refresh fail',
  props<{ error: string }>()
);

export const resetAuthError = createAction('[Auth] Reset auth error');
